import { html, type TemplateResult } from 'lit';

export interface AppNavProps {
  currentTab: string;
  onSelectTab: (tab: string) => void;
}

export function renderAppNavPresentation(props: AppNavProps): TemplateResult {
  const { currentTab, onSelectTab } = props;

  const tabs = [
    { id: 'about', label: 'ABOUT' },
    { id: 'posts', label: 'POSTS' },
  ];

  return html`
    <nav>
      ${tabs.map(
        t => html`
          <button
            class="${currentTab === t.id ? 'active' : ''}"
            @click=${() => onSelectTab(t.id)}
          >
            ${t.label}
          </button>
        `
      )}
    </nav>
  `;
}
